import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Row, Col, Form, Input, Button } from 'antd';

import { ownerLogin } from 'src/store/auth/actions';

import { IProps } from './types/owner';
import { Wrapper, Container } from './styles/owner.styles';
import { decorator } from 'src/utils';

const OwnerAuthScreen: React.FC<IProps> = (props) => {
  const onFinish = (values: any) => {
    setSending(true);
    return props.ownerLogin(values).catch(() => {
      setSending(false);
    });
  };

  const [sending, setSending] = useState(false);

  return (
    <Wrapper>
      <h1>Proprietário(a)</h1>
      <Container>
        <Form onFinish={onFinish} layout="vertical">
          <Form.Item label="E-mail" name="email" rules={decorator.email}>
            <Input size="large" placeholder="Insira o e-mail..." />
          </Form.Item>
          <Form.Item label="Senha" name="password" rules={decorator.password}>
            <Input.Password size="large" placeholder="Insira a senha..." />
          </Form.Item>
          <Row justify="center">
            <Button htmlType="submit" className="btn-success" loading={sending}>
              Entrar
            </Button>
          </Row>
        </Form>
        <br />
        <Row justify="center">
          <Link to="/proprietario/cadastrar/">
            Não tem uma conta? Cadastre-se!
          </Link>
        </Row>
      </Container>
    </Wrapper>
  );
};

export default connect(undefined, { ownerLogin })(OwnerAuthScreen);
